// hooks/useApi.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import env from "@beam-australia/react-env";

const axiosInstance = axios.create({
  baseURL: `${env("API_URL")}`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 150000,
  timeoutErrorMessage: "Tiempo de espera excedido",
});

const useAxiosInterceptor = () => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate("/");
  };

  const refreshToken = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    const newApi = axios.create({
      baseURL: `${env("API_URL")}`,
      headers: {
        "Content-Type": "application/json",
      },
    });

    const body = JSON.stringify({
      accessToken,
      refreshToken,
      origin: "backoffice",
    });

    const response = await newApi.post("base/auth/refreshtoken", body);

    console.log("response");
    console.log(response);

    localStorage.setItem("accessToken", response.data.accessToken.token);
    localStorage.setItem("refreshToken", response.data.refreshToken);

    return response.data.accessToken;
  };

  axiosInstance.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });

  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status === 401) {
          const originalRequest = error.config;

          try {
            const responseRefreshToken = await refreshToken();

            if (responseRefreshToken) {
              originalRequest.headers.Authorization = `Bearer ${localStorage.getItem(
                "accessToken"
              )} `;

              return axiosInstance(originalRequest);
            }
          } catch (err) {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            navigateToLogin();
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [navigate]);
};

const useApi = () => {
  useAxiosInterceptor();
  return axiosInstance;
};

export default useApi;

// // hooks/useApi.js
// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const axiosInstance = axios.create();

// axiosInstance.interceptors.request.use((config) => {
//   const accessToken = localStorage.getItem('accessToken');
//   if (accessToken) {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//   }
//   return config;
// });

// const useAxiosInterceptor = () => {
//   const navigate = useNavigate();

//   const navigateToLogin = () => {
//     navigate("/");
//   }

//   useEffect(() => {

//     const interceptor = axiosInstance.interceptors.response.use(
//       (response) => response,
//       (error) => {
//         let callback;

//         if (error.response) {
//           // La solicitud fue realizada y el servidor respondió con un código
//           // que está fuera del rango de 2xx
//           console.log(error.response.data);
//           console.log(error.response.status);
//           console.log(error.response.headers);
//           if (error.response?.status === 401) {
//             // Remover el accessToken inválido o expirado del almacenamiento local
//             localStorage.removeItem('accessToken');
//             error.callback = navigateToLogin;
//             console.log("error.callback");
//             console.log(error.callback);
//             navigate("/");
//           }

//         } else if (error.request) {
//           // La solicitud fue realizada pero no se recibió respuesta
//           console.log(error.request);
//         } else {
//           // Algo sucedió en la configuración de la solicitud que provocó un error
//           console.log('Error', error.message);
//         }

//         return Promise.reject(error);
//       }
//     );

//     return () => {
//       axiosInstance.interceptors.response.eject(interceptor);
//     };
//   }, [navigate]);
// };

// const useApi = () => {
//   useAxiosInterceptor();
//   return axiosInstance;
// };

// export default useApi;
